<template>
  <div class="dryer">
    <div class="content c895">
      <h2>Dodajte sušilni stroj</h2>
    </div>
    <div class="content c590">
      <div class="popup popDev7" :style="{display: !err ? 'none' : 'block'}">
        <div class="inner">
          <h3></h3>
          <div class="msg">
            <h3>Izpolniti je potrebno vsaj eno polje za pogostost uporabe naprave!</h3>
          </div>

          <div class="btns">
            <a href="javascript:void(0)" class="btn" title="OK" @click="err = false">V REDU</a>
          </div>
        </div>
      </div>
      <div class="form">
        <h3>VPIŠITE PODATKE O SUŠILNEM STROJU</h3>
        <div class="f-item select">
          <label>
            Energijski razred:
            <span
              id="ctl00_ContentPlaceHolder1_RequiredFieldValidator2"
              style="color:Red;float:none;font-size:1em;"
              :style="{visibility: !err2 ? 'hidden' : 'visible'}"
            >*</span>
            <span>(oz. leto izdelave naprave)</span>
          </label>
          <select v-model="kategorija">
            <option value="0">Izberite</option>
            <option value="1">A+++</option>
            <option value="2">A++</option>
            <option value="3">A (od 2010 dalje)</option>
            <option value="4">B (2007-2009)</option>
            <option value="5">C (2007)</option>
            <option value="6">D (pred 2007)</option>
            <option value="7">E (pred 2007)</option>
            <option value="8">F (pred 2007)</option>
          </select>
        </div>
      </div>
      <div class="question">
        <p>
          Kolikokrat
          <b>na teden</b> uporabljate sušilni stroj in kdaj?
        </p>
        <div class="help">
          <a href="#" class="help" title="Help">Help</a>
          <div class="tooltip">
            Na porabo elektrike in višino računa vpliva tarifa, v kateri sušite. Manjša tarifa velja med tednom ponoči (od 22.00 do 6.00) ter ob sobotah, nedeljah ter dela prostih dnevih cel dan.
            <p></p>
          </div>
        </div>
      </div>
      <div class="answer-list">
        <ul>
          <li class="first">
            <div>PON-PET, 6:00-22:00</div>
            <div>PON-PET, 22:00-6:00 IN SOB-NED</div>
          </li>
          <li class="answer odd">
            <span class="small">št. sušenj</span>
            <div>
              <input v-model="teden" type="text" />
              <span>x</span>
            </div>
            <div class="last">
              <input v-model="vikend" type="text" />
              <span>x</span>
            </div>
          </li>
        </ul>
      </div>
      <div class="add">
        <input type="submit" value="Dodaj" @click="addedApplianceNum()" />
      </div>
    </div>
    <div class="content r-c">
      <div class="c282 info">
        <h3>INFO O SUŠILNEM STROJU</h3>
        <p>Opremljenost predvsem mestnih gospodinjstev s sušilnimi stroji se iz leta v leto povečuje. Letna poraba sušilnih strojev sledi porabi pralnih strojev, vendar je tudi pri teh poraba energije odvisna od kakovosti aparata. Priključne moči sušilnih strojev so od 1,5 kW do 3 kW.</p>

        <div class="average">
          <h4>Povprečna poraba sušilnega stroja za 4 člansko družino na leto</h4>
          <span>330 kWh/leto</span>
          <p>
            <strong>24,91 € / leto</strong> (enotarifno)
            <br />
            <strong>21,36 € / leto</strong> (dvotarifno)
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SusilniStrojObj from '../classes/susilni_stroj';

export default {
  data: function () {
    return {
      kategorija: '0',
      teden: 0,
      vikend: 0,
      err: false,
      err2: false,
    };
  },
  methods: {
    addedApplianceNum() {
      const SS = new SusilniStrojObj(this.kategorija, this.teden, this.vikend);

      this.$emit('applianceFormClicked', SS);
    },
  },
};
</script>

<style>
</style>